import { httpGet } from './utils';

const api = {
  getEssentials: httpGet,
};

export default api;
